import axios from 'axios';
import { FileSummary } from 'views/sea-cloud-file-upload/types/file-summary.type';
import { ImportStatus } from '../types/import-status.type';

// POST
// Uploads file to SeaCloud
// /ewosapi/v1/SeaCloudFileUpload/{globalCompanyId}/{fileName}
export const postSeaCloudFileUpload = async (globalCompanyId: string, fileName: string, file: File): Promise<FileSummary> => {
  const res = await axios.post<FileSummary>(`/ewosapi/v1/SeaCloudFileUpload/${globalCompanyId}/${fileName}`, file, {
    headers: {
      'Content-Type': 'text/xml',
    },
  });

  return res.data;
};

// POST
// Sets status of the preloaded file. This method starts actual import or discards file.
// /ewosapi/v1/SeaCloudFileUpload/{globalCompanyId}/{importId}/{confirm}
export const postSeaCloudFileImportStatus = async (
  globalCompanyId: string,
  importId: number,
  confirm: boolean
): Promise<ImportStatus> => {
  const res = await axios.post<ImportStatus>(`/ewosapi/v1/SeaCloudFileUpload/${globalCompanyId}/${importId}/${confirm}`);
  return res.data;
};
